/* unplugin-vue-components disabled */import script from "./StudyDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudyDetails.vue?vue&type=script&setup=true&lang=ts"

import "./StudyDetails.vue?vue&type=style&index=0&id=3249d8b9&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3249d8b9"]])

export default __exports__